import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PhpackagingmaterialDashboard from '../PhpackagingmaterialDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PhpackagingmaterialPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PhpackagingmaterialDashboard />
    )

}